import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axiosClient from "../api/axiosClient";   // ✅ ADD THIS
import { getCourseTheme } from "../script/coursesGetcourses"
import { styles } from "../script/coursesStyles";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

import {
  SiCplusplus,
  SiPython,
  SiJavascript,
  SiDatabricks
} from "react-icons/si";

import { FaJava } from "react-icons/fa";

import "../styles/Courses.css"


const courseIcons = {
  c: <SiCplusplus size={30} color="#00599C" />,
  "java": (
    <img
      src="/java.png"
      alt="java"
      style={{ width: "30px", height: "30px", objectFit: "contain" }}
    />
  ),
  "python": (
    <img
      src="/python.png"
      alt="python"
      style={{ width: "30px", height: "30px", objectFit: "contain" }}
    />
  ),


  "data science": (
    <img
      src="/exploratory-analysis.png"
      alt="Data Science"
      style={{ width: "30px", height: "30px", objectFit: "contain" }}
    />
  ),

  dsa: (
    <img
      src="/data.png"
      alt="DSA"
      style={{ width: "30px", height: "30px", objectFit: "contain" }}
    />
  ),
};

// --- ROADMAP MODAL ---
const DetailModal = ({ isOpen, onClose, content, loading }) => {
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const [scrollPercent, setScrollPercent] = useState(0);
  const [viewHistory, setViewHistory] = useState([]);
  const [currentView, setCurrentView] = useState(null);

  useEffect(() => {
    if (content) {
      setCurrentView(content);
      setViewHistory([content]);
    }
  }, [content]);


  const handleScroll = () => {
    if (scrollRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
      const totalScroll = scrollHeight - clientHeight;
      setScrollPercent((scrollTop / (totalScroll || 1)) * 100);
    }
  };

  const handleNextLevel = (step) => {
    if (step.children && step.children.length > 0) {
      setViewHistory((prev) => [...prev, step]);
      setCurrentView(step);
      setScrollPercent(0);
      scrollRef.current?.scrollTo(0, 0);
    }
  };

  const handleGoBack = () => {
    if (viewHistory.length > 1) {
      const newHistory = [...viewHistory];
      newHistory.pop();
      const previous = newHistory[newHistory.length - 1];
      setViewHistory(newHistory);
      setCurrentView(previous);
      setScrollPercent(0);
    } else {
      onClose();
    }
  };

  if (!isOpen || !content) return null;

  const baseCourse = viewHistory?.[0];
  const theme = getCourseTheme(baseCourse?.name || baseCourse?.course || "");
  const stepsToShow = currentView?.children || [];

  return (
    <div id="pb-modal-root" style={styles.fullModalOverlay}>
      <div className="pb-modal-content-wrapper" style={styles.fullModalContent}>
        <div className="pb-modal-left-panel" style={{ ...styles.leftPanel, background: theme.gradient }}>
          <div style={styles.leftContent}>
            <div className="pb-hero-icon-bounce pb-mobile-hide-icon" style={styles.heroIconBox}>
              {theme.icon}
            </div>
            <h2 className="pb-mobile-title-small" style={styles.heroTitleLarge}>
              {(currentView?.name || currentView?.course || "").replace(/_/g, " ")}
            </h2>
            <p className="pb-mobile-hide-text" style={styles.heroSubtitle}>
              {viewHistory.length > 1 ? "Deep-Dive Training" : "Comprehensive Master Roadmap"}
            </p>
            <button onClick={handleGoBack} style={styles.backBtn}>
              {viewHistory.length > 1 ? "← Back to Previous" : "Close Roadmap"}
            </button>
            <div style={styles.finalActionArea}>
              <button type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  const token = localStorage.getItem("token");
                  if (token) {
                    navigate("/payment", { state: { courseName: viewHistory?.[0]?.name || viewHistory?.[0]?.course } });
                    return;
                  }
                  Swal.fire({
                    title: "Login Required",
                    text: "Please login first to continue your enrollment.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#9c00e4",
                    confirmButtonText: "Login Now",
                    didOpen: () => {
                      const popup = document.querySelector(".swal2-container");
                      if (popup) popup.style.zIndex = "100000";
                    },
                  }).then((result) => {
                    if (result.isConfirmed) {
                      navigate("/login", { state: { redirectTo: "/payment", courseName: viewHistory?.[0]?.name || viewHistory?.[0]?.course } });
                    }
                  });
                }}
                style={{ ...styles.finalGetStartedBtn, backgroundColor: theme.color }}>
                Enroll Now
              </button>
            </div>
          </div>
        </div>

        <div className="pb-custom-scroll pb-modal-right-panel" style={styles.rightPanel} ref={scrollRef} onScroll={handleScroll}>
          {loading ? (
            <div style={styles.loaderCenter}><div className="pb-pulse-loader"></div></div>
          ) : (
            <div style={styles.roadmapFlow}>
              <div style={styles.breadcrumb}>
                {viewHistory.map((v, i) => (
                  <span key={i}> {v.name || v.course} {i < viewHistory.length - 1 && " / "} </span>
                ))}
              </div>

              <h3 className="pb-flow-title-text" style={styles.flowTitle}>
                {stepsToShow.length > 0 ? "What's in this phase?" : "Level Completed"}
              </h3>

              <div style={styles.timelineWrapper}>
                <div style={styles.timelineBaseLine}></div>
                <div style={{ ...styles.timelineFillLine, height: `${scrollPercent}%`, backgroundColor: theme.color }}></div>

                <div style={{ ...styles.zestyTraveler, top: `calc(${scrollPercent}% - 40px)` }}>
                  <img src="Zesty Hii1.png" alt="Zesty" className="pb-zesty-img-mobile" style={styles.zestyImg} />
                </div>

                <div style={styles.stepsContainer}>
                  {stepsToShow.map((step, i) => {
                    const hasChildren = step.children && step.children.length > 0;
                    return (
                      <div key={i} style={styles.flowItem} onClick={() => hasChildren && handleNextLevel(step)}>
                        <div className="pb-flow-number-circle" style={{
                          ...styles.flowNumber,
                          backgroundColor: scrollPercent > (i / stepsToShow.length) * 100 ? theme.color : "#fff",
                          color: scrollPercent > (i / stepsToShow.length) * 100 ? "#fff" : "#cbd5e1",
                        }}>
                          {i + 1}
                        </div>

                        <div className={`pb-roadmap-card-mobile ${hasChildren ? "pb-clickable-card" : ""}`}
                          style={{ ...styles.flowCard, borderLeft: `6px solid ${theme.color}`, cursor: hasChildren ? "pointer" : "default" }}>
                          <div style={{ ...styles.cardTag, color: theme.color, background: theme.bg }}>
                            {hasChildren ? "CLICK TO EXPLORE" : "FINAL STEP"}
                          </div>
                          <h4 style={styles.cardTitle}>{step.name?.replace(/_/g, " ")}</h4>
                          <p style={styles.cardText}>{step.description || "Details about this specific training module."}</p>
                          {hasChildren && <div style={{ ...styles.exploreMore, color: theme.color }}>View Sub-Roadmap →</div>}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div style={styles.finalActionArea}>
                <button type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    const token = localStorage.getItem("token");
                    if (token) {
                      navigate("/payment", { state: { courseName: viewHistory?.[0]?.name || viewHistory?.[0]?.course } });
                      return;
                    }
                    Swal.fire({
                      title: "Login Required",
                      text: "Please login first to continue your enrollment.",
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#9c00e4",
                      confirmButtonText: "Login Now",
                      didOpen: () => {
                        const popup = document.querySelector(".swal2-container");
                        if (popup) popup.style.zIndex = "100000";
                      },
                    }).then((result) => {
                      if (result.isConfirmed) {
                        navigate("/login", { state: { redirectTo: "/payment", courseName: viewHistory?.[0]?.name || viewHistory?.[0]?.course } });
                      }
                    });
                  }}
                  style={{ ...styles.finalGetStartedBtn, backgroundColor: theme.color }}>
                  Enroll Now
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>

  );
};

// --- DASHBOARD ---
export default function Dashboard() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [detailData, setDetailData] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
   const location = useLocation();

// const hideNav = localStorage.getItem("hideNav");

  const checkIsPaid = (courseId) => {
    const paidCourses = JSON.parse(localStorage.getItem("paidCourses") || "[]");
    return paidCourses.includes(courseId);
  };


  useEffect(() => {
    const loadTree = async () => {
      try {
        const res = await axiosClient.get("/no-auth/api/users/tree");

        const finalData = res.data?.data || res.data;
        setData(Array.isArray(finalData) ? finalData : []);
      } catch (err) {
        console.error("❌ Tree API failed:", err);
        Swal.fire({
          icon: "error",
          title: "Server Error",
          text: "Unable to load courses. Please try again later.",
        });
      } finally {
        setLoading(false);
      }
    };

    loadTree();
  }, []);

    // ✅ ADD THIS: auto-open the course that was clicked in the navbar
  useEffect(() => {
    const targetCourse = location.state?.course;
    if (!targetCourse || loading || data.length === 0) return;

    const match = data.find(
      (item) =>
        (item.name || item.course || "").toLowerCase() ===
        targetCourse.toLowerCase()
    );

    if (match) {
      handleCardClick(match);
    }

    // clear the state so re-visiting /courses normally doesn't re-trigger it
    navigate(location.pathname, { replace: true, state: {} });
  }, [loading, data]); // runs once data is ready

  const handleCardClick = async (item) => {
    localStorage.setItem("selectedCourse", item.name || item.course);

    if (checkIsPaid(item.id)) {
      navigate(`/coding-phase/${item.id}`);
      return;
    }
    try {
      setDetailLoading(true);
      const res = await axiosClient.get(`/no-auth/api/users/tree/${item.id}`);
      setDetailData(res.data?.data || res.data);
      setIsModalOpen(true);
    } catch (err) {
      Swal.fire("Error", "Failed to load roadmap data", "error");
    } finally {
      setDetailLoading(false);
    }
  };


  return (

    <>

      <Helmet>
        <title>Programming Courses & Learning Roadmaps | Python, Java, DSA & Data Science</title>
        <meta
          name="description"
          content="Explore industry-focused learning roadmaps for Python, Java, Data Science, DSA, and C programming. Build job-ready coding skills with beginner-to-advanced technical training courses." />
      </Helmet>



      <div id="pb-dashboard-container" style={styles.page}>

        <div style={styles.headerArea}>
          <h1 style={styles.pageTitle}>Learning Universe</h1>
          <p style={{ color: "#64748b" }}>Select a path to start your journey</p>
        </div>

        <div className="pb-dashboard-grid">
          {!loading && data
            .filter(item =>
              ["data science", "dsa", "python", "java", "c"].includes(
                (item.name || item.course)?.toLowerCase()
              )
            )
            .map((item, index) => {
              const rawName = item.name || item.course || "";
              const name = rawName.toLowerCase();

              let theme = getCourseTheme(rawName);

              const iconKey = name.toLowerCase();
              if (courseIcons[iconKey]) {
                theme = {
                  ...theme,
                  icon: courseIcons[iconKey]
                };
              }

              // 🔥 SAFE ICON OVERRIDE
              // if (name === "c") {
              //   theme = {
              //     ...theme,
              //     icon: <span style={{ fontSize: "22px" }}>©️</span>
              //   };
              // }

              // if (name.includes("java")) {
              //   theme = {
              //     ...theme,
              //     icon: <span style={{ fontSize: "22px" }}>🍵</span>
              //   };
              // }

              const isPaid = checkIsPaid(item.id);

              return (
                <div key={index} className="pb-main-card" onClick={() => handleCardClick(item)}>
                  {isPaid && <div className="pb-paid-badge">ENROLLED</div>}

                  <div style={{ ...styles.iconBox, background: theme.bg }}>
                    {theme.icon}
                  </div>

                  <h3 style={styles.itemTitle}>
                    {rawName.replace(/_/g, " ")}
                  </h3>

                  <p style={styles.cardDescText}>{item.description}</p>

                  <div style={{ marginTop: "15px", color: theme.color, fontWeight: "bold" }}>
                    {isPaid ? "Continue Coding →" : "Explore Roadmap →"}
                  </div>
                </div>
              );
            })
          }
        </div>

        <DetailModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} content={detailData} loading={detailLoading} />
      </div>
    </>
  );
}
